import { useStyles } from '@webapps/styles';

const Playground = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div>
      <div style={{ padding: spacing(2), gap: spacing(2), display: 'flex', flexDirection: 'row' }}>
        {/* ---- BOUTONS ---- */}
        <button className={classes.ButtonPrimary}>Button Primary</button>
        <button className={classes.ButtonSecondary}>Button Secondary</button>
        <button className={classes.ButtonTertiary}>Button Tertiary</button>
        <button className={classes.ButtonQuaternary}>Button Quaternary</button>
      </div>
      <div style={{ padding: spacing(2), gap: spacing(2), display: 'flex', flexDirection: 'row' }}>
      {/* ---- BOUTONS SPECIAUX ---- */}
    </div>
  </div>
  );
};

const styles = ({ spacing }) => ({
  ButtonPrimary: {
    fontSize: '13.5px',
    color: '#FFFFFF',
    height: '40px',
    backgroundColor: '#0060F9',
    padding: '5px 30px 5px 30px',
    borderRadius: '40px',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600, // Semibold
    border: 'none',
    '&:hover': {
      backgroundColor: '#004AC1',
    },
    '&:focus': {
      backgroundColor: '#004AC1',
      outline: 'none',
    },
    },
    ButtonSecondary: {
    fontSize: '13.5px',
    color: '#0060F9',
    height: '40px',
    backgroundColor: '#C0D9FF',
    padding: '5px 30px 5px 30px',
    borderRadius: '40px',
    border: '1px solid #0060F9',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600, // Semibold
    '&:hover': {
      backgroundColor: '#0060F9',
      color: '#FFFFFF',
      outline: 'none',
    },
    '&:focus': {
      backgroundColor: '#004AC1',
      color: '#FFFFFF',
      outline: 'none',
    },
  },
  ButtonTertiary: {
    fontSize: '13.5px',
    color: '#0060F9',
    height: '40px',
    backgroundColor: '#F3F7FF',
    padding: '5px 30px 5px 30px',
    borderRadius: '40px',
    border: '1px solid #0060F9',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600, // Semibold
    '&:hover': {
      backgroundColor: '#0060F9',
      color: '#FFFFFF',
      outline: 'none',
    },
    '&:focus': {
      backgroundColor: '#004AC1',
      color: '#FFFFFF',
      outline: 'none',
    },
  },
  ButtonQuaternary: {
    fontSize: '13.5px',
    color: '#5D75A8',
    height: '40px',
    backgroundColor: '#F3F7FF',
    padding: '5px 30px 5px 30px',
    borderRadius: '40px',
    border: '1px solid #C0D9FF',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600, // Semibold
    '&:hover': {
      color: '#0060F9',
      border: '1px solid #0060F9',
      outline: 'none',
    },
    '&:focus': {
      color: '#0060F9',
      border: '1px solid #0060F9',
      outline: 'none',
    },
  },
  ButtonSpécial1: {
    fontSize: '13.5px',
    color: '#5D75A8',
    height: '40px',
    backgroundColor: '#F3F7FF',
    padding: '5px 30px 5px 30px',
    borderRadius: '40px',
    border: '1px solid #C0D9FF',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600, // Semibold
    '&:hover': {
      color: '#0060F9',
      border: '1px solid #0060F9',
      outline: 'none',
    },
    '&:focus': {
      color: '#0060F9',
      border: '1px solid #0060F9',
      outline: 'none',
    },
  },
});

export default Playground;
